import { render } from "./dummyComponent.vue?vue&type=template&id=89e9b76a"
import script from "./dummyComponent.vue?vue&type=script&lang=js"
export * from "./dummyComponent.vue?vue&type=script&lang=js"
script.render = render

export default script